import React from 'react';
import ReactDOM from 'react-dom/client';
import IntlProviderHOC from './IntlHoc';
import { Provider } from 'react-redux'
import { store } from './store';
import Routes from "./Routes";
import reportWebVitals from './reportWebVitals';
import "./assets/css/main.css"
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <IntlProviderHOC>
      <Routes />
    </IntlProviderHOC>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
